var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#45029C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1759 18.8008C27.1679 18.8008 29.0399 20.3528 29.0399 22.8648C29.0399 25.3608 27.1679 26.9128 24.1759 26.9128H21.9199V30.0008H19.3279V18.8008H24.1759ZM24.0319 24.8008C25.6159 24.8008 26.4159 24.0808 26.4159 22.8648C26.4159 21.6328 25.6159 20.9128 24.0319 20.9128H21.9199V24.8008H24.0319Z",
    fill: "#F6F4F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProject);
export default __webpack_public_path__ + "static/media/defaultProject.53ef5054a80656e443cb2653008daaa0.svg";
export { ForwardRef as ReactComponent };